document.addEventListener('DOMContentLoaded', () => {
  const rows = document.querySelectorAll('.word-row');
  const section = document.querySelector('.insight-card');

  let currentHighlightedRow = null;
  let scrollStopped = false;
  let sectionTriggered = false;

  /* 🔀 0️⃣ RANDOMIZE words inside each row (NEW) */
  rows.forEach(row => {
    const words = Array.from(row.querySelectorAll('.word'));

    // Fisher–Yates shuffle
    for (let i = words.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [words[i], words[j]] = [words[j], words[i]];
    }

    // Re-append shuffled words
    words.forEach(word => row.appendChild(word));
  });

  /* 1️⃣ Assign ONE active word per row */
  rows.forEach((row, rowIndex) => {
    const words = row.querySelectorAll('.word');
    words.forEach(w => w.classList.remove('active', 'is-highlighted'));

    const fixedIndex = rowIndex % words.length;
    words[fixedIndex]?.classList.add('active');
  });

  /* 2️⃣ Stop scrolling AFTER section enters viewport */
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting || sectionTriggered) return;

      sectionTriggered = true;

      /* Let animation run briefly, then stop */
      setTimeout(() => {
        rows.forEach(row => {
          row.style.animationPlayState = 'paused';
        });
        scrollStopped = true;
      }, 2200); // tweak if needed
    });
  }, { threshold: 0.25 });

  if (section) observer.observe(section);

  /* 3️⃣ Scroll-based SWITCH highlighting */
  window.addEventListener('scroll', () => {
    if (!scrollStopped) return;

    const viewportCenter = window.innerHeight / 2;
    let newHighlightedRow = null;

    rows.forEach(row => {
      const rect = row.getBoundingClientRect();
      const rowCenter = rect.top + rect.height / 2;

      if (Math.abs(rowCenter - viewportCenter) < rect.height / 2) {
        newHighlightedRow = row;
      }
    });

    if (newHighlightedRow !== currentHighlightedRow) {

      /* OFF previous immediately */
      if (currentHighlightedRow) {
        currentHighlightedRow
          .querySelector('.word.active')
          ?.classList.remove('is-highlighted');
      }

      /* ON new smoothly */
      if (newHighlightedRow) {
        newHighlightedRow
          .querySelector('.word.active')
          ?.classList.add('is-highlighted');
      }

      currentHighlightedRow = newHighlightedRow;
    }
  });
});
